import { baseSupabase as originalSupabase } from '../integrations/supabase/client';

let allowConnectionsQueries = false;

export async function withConnectionsAccess<T>(fn: () => Promise<T>): Promise<T> {
  allowConnectionsQueries = true;
  try {
    return await fn();
  } finally {
    allowConnectionsQueries = false;
  }
}

// 🚀 V167: CRITICAL FIX - Use a simpler approach that doesn't break method chaining
// Only intercept 'from' calls for 'connections' table, otherwise pass through
export const supabase = new Proxy(originalSupabase as any, {
  get(target: any, prop: string, receiver: any) {
    if (prop === 'from') {
      // 🚀 V167: CRITICAL FIX - Get the original 'from' method and wrap it
      const originalFrom = target[prop];
      return function(table: string) {
        if (table === 'connections' && !allowConnectionsQueries) {
          // V167.FIX: Don't log as error - this is expected and caught gracefully
          // Only throw the error, let the caller decide how to handle it
          throw new Error('Direct connection queries are disabled. Use NetworkDataContext.');
        }
        // 🚀 V167: CRITICAL FIX - Call the original method directly on the target
        // This preserves the query builder's method chain
        return originalFrom.call(target, table);
      };
    }
    
    // 🚀 V167: CRITICAL FIX - For all other properties, return them directly
    // Use Reflect.get to maintain proper prototype chain
    return Reflect.get(target, prop, receiver);
  }
});


